import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";
import HorasExtrasPendentesStore from "../stores/HorasExtrasPendentesStore";
import {
    formatarValorReal, motivoContratacaoFormatter, mudarDiasAlerta, nullable, ordenarData, ordenarSLA,
    slaFormatter
} from "../../../utils/formatar";
import ParametrosGeraisStore from "../../administracao/stores/ParametrosGeraisStore";
import {formatarDataISO8601} from "../../../utils/formatar";
import {Form, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader, Button} from "reactstrap";
import Dropzone from 'react-dropzone'
import loading from '../../../assets/images/ajax-loader.gif';
import PagamentosPendentesStore from "../stores/PagamentosPendentesStore";


@inject("store")
@DataWrapper
@observer
export class PagamentosPendentes extends Component {
    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.modalStore                 = this.props.store.modalStore;
        this.loginStore                 = this.props.store.loginStore;
        this.controller                 = new PagamentosPendentesStore();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Pagamentos");

        this.controller.carregarLista();

        /*TODO: caso for usar botões de ordenação de filtro
        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            }
        ]);
        */
    }

    obterTituloMobile = (objeto) => {
        return  (objeto.idSolicitacaoExibicao != null ? "#" + objeto.idSolicitacaoExibicao + " - " : "") + objeto.tarefa+ ", Lote " +objeto.id;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "SLA: "}<div  style={{display: "inline-block"}}>{slaFormatter(objeto.sla, objeto)}</div><br/>
                { "Prazo: " + nullable(formatarDataISO8601(objeto.prazo))}<br/>
                { "Unidade de negócio (BU): " + nullable(objeto.nomeEmpresaGlobo)}<br/>
                { "Qtde MOTs: " + nullable(objeto.quantidadeMOTs)}<br/>
                { "Valor total: " + nullable(formatarValorReal(objeto.valorTotal))}<br/>
                { "Data geração: " + nullable(formatarDataISO8601(objeto.dataGeracao))}
            </div>
        )
    };

    formatoJornada = (cell) => {
        return cell ? cell + " horas" : "";
    };

    importarPlanilha = () => {
        this.controller.toogleImportModal();
    };


    render() {
        const colunas = [
            {
                field: "tarefa",
                label: "Tarefa",
            },{
                field: "prazo",
                label: "Prazo",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("prazo"),
            },{
                field: "sla",
                label: "SLA",
                dataFormat: slaFormatter,
                funcaoOrdenacao: ordenarSLA.bind("prazo"),
            },{
                field: "id",
                label: "Lote",
            },{
                field: "nomeEmpresaGlobo",
                label: "Unidade de negócio (BU)",
            },{
                field: "quantidadeMOTs",
                label: "Qtde MOTs"
            },{
                field: "valorTotal",
                label: "Valor total",
                dataFormat: formatarValorReal
            },{
                field: "dataGeracao",
                label: "Data geração",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataGeracao")
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        <TabelaFluxo
                            keyField={"id"}
                            nomeFluxo={'Pagamento'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.pagamentos}
                            colunas={colunas}
                            temBusca={true}
                            parametroVisualizar={"id"}
                            acoesItens={["visualizar"]}
                            acoesMultiplas={[]}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

